module.exports = __webpack_public_path__ + "fonts/Inter-500-latin56.30a274c.woff2";